import { object, string } from 'yup';

export const couponClaimSchema = () =>
  object({
    code: string().required('The field is required'),
  });
